import * as React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

const LoadingComponent = (props) => {
    const {label} = props
    return (
        <div className='h-100'>
            <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                <CircularProgress />
                <p>{label}</p>
            </Box>
        </div>
    );
}

export default LoadingComponent;
